import axios from '@/axios';
import { useBookingStore } from '@/stores/booking';
import type { Employee } from '@/types';
import widgetSettings from '@/widget-settings';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';

export const useEmployeesStore = defineStore('employees', () => {
  const employees = ref<Employee[]>([]);
  const loading = ref(false);

  const fetchEmployees = () => {
    const { locationId, serviceIds } = useBookingStore();
    loading.value = true;

    axios
      .get(`/locations/${locationId}/resources`, {
        params: {
          service_ids: serviceIds,
          widget_id: widgetSettings.widgetId
        }
      })
      .then(({ data: { resources } }) => {
        employees.value = resources;
        loading.value = false;
      });
  };

  return {
    employees,
    loading,
    fetchEmployees
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEmployeesStore, import.meta.hot));
}
